// removed by extract-text-webpack-plugin
module.exports = {"heading-with-number":"styles__heading-with-number___2Qipt","info-text":"styles__info-text___3KzQn","active-child-rule-container":"styles__active-child-rule-container___3Ju0E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GeneratedChildRules/styles.scss
// module id = 7637
// module chunks = 0